<template>
    <div class="view view__room_show">
        <room-show/>
    </div>
</template>

<script>
import RoomShow from '@/components/ebs/rooms/show/RoomShow'

export default {
  components: { RoomShow },
  name: 'view-room-show',
  computed: {
    routeRoomId: function () {
      return this.$route.params.roomId
    },
    //
    roomId: function () {
      return this.$store.getters.getRoomId
    }
  },
  methods: {
    getRoom: function () {
      const roomID = this.$route.params.roomId
      this.$store.dispatch('getRoom', roomID)
    }
  },
  watch: {
    roomId: function () {
      if (this.roomId) {
        this.$eventBus.$emit('stop-loading')
      }
    }
  },
  created () {
    this.getRoom()
  },
  mounted () {
    if (!this.roomId) {
      this.$eventBus.$emit('start-loading')
    }
  }
}
</script>
